import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	ProductChange,
	ProductSizeOption,
	RecalculateResult,
} from "../models/ProductChange";

export const getProductChanges = async (): Promise<ProductChange[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	const resp = await apiService.callV2(
		"[MILL].[GetProductChanges]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as ProductChange[];
	}
	throw new Error(resp.message || "Error fetching product changes");
};

export const upsertProductChange = async (
	change: ProductChange,
): Promise<ProductChange> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: change.Id },
		{ name: "InitialProductSizeId", value: change.InitialProductSizeId },
		{ name: "FinalProductSizeId", value: change.FinalProductSizeId },
		{ name: "GoalTime", value: change.GoalTime },
	];

	const resp = await apiService.callV2(
		"[MILL].[UpsertProductChanges]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as ProductChange;
	}
	throw new Error(resp.message || "Error saving product change");
};

export const removeProductChange = async (id: number): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Id", value: id }];

	const resp = await apiService.callV2(
		"[MILL].[RemoveProductChange]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting product change");
	}
};

export const recalculateProductChange = async (
	id: number,
): Promise<RecalculateResult> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "ProductChangeId", value: id }];

	const resp = await apiService.callV2(
		"[MILL].[RecalculateProductChangesTime]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", {
			AverageChangeTime: null,
			NumberOfChanges: null,
		}) as RecalculateResult;
	}
	throw new Error(resp.message || "Error recalculating product change");
};

export const getActiveProductSizes = async (): Promise<ProductSizeOption[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: true }];

	const resp = await apiService.callV2(
		"[MILL].[GetProductSizes]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as ProductSizeOption[];
	}
	throw new Error(resp.message || "Error fetching product sizes");
};
